module.exports = __webpack_public_path__ + "img/2d0aeef4-36a1-45a1-887d-93a5be2d8fe2.7ca487d1.svg";